/**
 * JDM City Virginia - Theme JavaScript Core
 * Horizontal Product Carousel, YMM Fitment Filter, Navigation Drawer
 */

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initYMMFinder();
  initMobileMenu();
  initProductSliders();
  initCategorySlider();
});

// Category Carousel Slider Navigation
function initCategorySlider() {
  const track = document.getElementById('CategorySliderTrack');
  const prevBtn = document.querySelector('.cat-prev-btn');
  const nextBtn = document.querySelector('.cat-next-btn');

  if (!track) return;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -330, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: 330, behavior: 'smooth' });
    });
  }
}

// Sticky Header Transition
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });
}

// Make / Model / Engine Interactive Filter
function initYMMFinder() {
  const forms = document.querySelectorAll('.hero-fitment-grid');
  if (!forms.length) return;

  const mockData = {
    'Toyota': {
      'Supra': ['2JZ-GTE VVTi', '1JZ-GTE VVTi', '7M-GTE'],
      'Chaser': ['1JZ-GTE VVTi', '1JZ-GTE Non-VVTi'],
      'MR2': ['3S-GTE Turbo', '3S-GE NA']
    },
    'Honda': {
      'Civic': ['K20A Type R', 'B16B Type R', 'K24A2 VTEC', 'D16Z6'],
      'Integra': ['B18C Spec R', 'K20A Type R'],
      'S2000': ['F20C VTEC', 'F22C1 VTEC']
    },
    'Nissan': {
      'Skyline GT-R': ['RB26DETT N1', 'RB26DETT Twin Turbo', 'RB25DET Neo'],
      'Silvia 240SX': ['SR20DET Blacktop', 'SR20DET Redtop', 'CA18DET'],
      '350Z': ['VQ35DE RevUp', 'VQ35HR Twin Intake']
    },
    'Subaru': {
      'Impreza WRX STI': ['EJ205 Turbo', 'EJ207 Spec C', 'EJ257 STI'],
      'Legacy B4': ['EJ20X Twin Scroll', 'EJ20Y']
    },
    'Mazda': {
      'RX-7': ['13B-REW Twin Turbo', '13B-DE NA'],
      'Miata MX-5': ['BP-ZE 1.8L', 'B6-ZE 1.6L']
    },
    'Mitsubishi': {
      'Lancer Evolution': ['4G63T Evo 8', '4G63T Evo 9 MIVEC', '4G63T Evo 4-7']
    },
    'Lexus': {
      'IS300': ['2JZ-GE VVTi'],
      'GS300': ['2JZ-GE VVTi']
    },
    'Acura': {
      'RSX Type S': ['K20A2 VTEC'],
      'TSX': ['K24A2 VTEC']
    }
  };

  forms.forEach(form => {
    const makeSelect = form.querySelector('#ymm-make, .ymm-make-select');
    const modelSelect = form.querySelector('#ymm-model, .ymm-model-select');
    const engineSelect = form.querySelector('#ymm-engine, .ymm-engine-select');

    if (!makeSelect || !modelSelect || !engineSelect) return;

    makeSelect.addEventListener('change', (e) => {
      const selectedMake = e.target.value;
      modelSelect.innerHTML = '<option value="">2. SELECT MODEL</option>';
      engineSelect.innerHTML = '<option value="">3. SELECT ENGINE / SWAP</option>';

      if (selectedMake && mockData[selectedMake]) {
        Object.keys(mockData[selectedMake]).forEach(model => {
          const option = document.createElement('option');
          option.value = model;
          option.textContent = model.toUpperCase();
          modelSelect.appendChild(option);
        });
      }
    });

    modelSelect.addEventListener('change', (e) => {
      const selectedMake = makeSelect.value;
      const selectedModel = e.target.value;
      engineSelect.innerHTML = '<option value="">3. SELECT ENGINE / SWAP</option>';

      if (selectedMake && selectedModel && mockData[selectedMake][selectedModel]) {
        mockData[selectedMake][selectedModel].forEach(engine => {
          const option = document.createElement('option');
          option.value = engine;
          option.textContent = engine.toUpperCase();
          engineSelect.appendChild(option);
        });
      }
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const make = makeSelect.value;
      const engine = engineSelect.value;

      if (!make) {
        alert('Please select a Brand / Make first to filter JDM inventory.');
        return;
      }

      let targetUrl = `/collections/all?filter.v.m=${encodeURIComponent(make)}`;
      if (engine) {
        targetUrl += `&q=${encodeURIComponent(engine)}`;
      }
      window.location.href = targetUrl;
    });
  });
}

// Horizontal Product Slider Controls
function initProductSliders() {
  const sliderTracks = document.querySelectorAll('.product-slider-track');
  
  sliderTracks.forEach(track => {
    const container = track.closest('.slider-container-wrapper');
    if (!container) return;

    const prevBtn = container.querySelector('.slider-prev-btn');
    const nextBtn = container.querySelector('.slider-next-btn');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -300, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 300, behavior: 'smooth' });
      });
    }
  });
}

// Mobile Navigation Drawer
function initMobileMenu() {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const mobileDrawer = document.querySelector('.mobile-navigation-drawer');
  const closeBtn = document.querySelector('.mobile-drawer-close');

  if (!toggleBtn || !mobileDrawer) return;

  toggleBtn.addEventListener('click', () => {
    mobileDrawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      mobileDrawer.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }
}
